import { Modal } from '@chikara/ui';
import { t } from '@/i18n';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function LogoutConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
}: LogoutConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('logout.title')}
      description={t('logout.subtitle')}
      actionLabel={t('logout.action')}
      onAction={onConfirm}
      secondaryActionLabel={t('logout.secondaryAction')}
      onSecondaryAction={onClose}
      secondaryActionVariant="button"
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseButton={false}
    />
  );
}
